import BuildProperties from "@/envconfig/BuildProperties";

/* URL/host helpers needed by the router at startup. Kept out of lib/utils
   (which re-exports them) so the initial bundle doesn't include
   moment-timezone. */

export function getSubDomain() {
  if(window.location?.port?.length>0 && window.location?.port === '3000'){
     // for testing pass test
    // return "test"
    return null
  }else{
    const subdomain = window.location.hostname?.split(".")[0]
    if(subdomain?.toLowerCase() != "qa" && !BuildProperties.isProdEnv()){
      return subdomain
    }else{
      // for testing pass test

      return null
    }

  }
}

export function IsDBLURL() {
  if (typeof window === "undefined") return null;

  // Expected: /b/:venue_slug/:dbl_id
  const match = window.location.pathname.match(/^\/b\/([^/]+)\/([^/]+)/);

  if (!match) return null;
  // console.log(match,match[1], match[2])
  const isDBL = match[1] && match[2]
  return isDBL
}
